module.exports = __webpack_public_path__ + "img/solution_icon7.ee237448.png";